<div class="manage-menu-shell">
  @if (mobileSidebarOpen) {
    <button type="button" class="manage-menu-shell__backdrop" aria-label="Close sidebar" (click)="closeMobileSidebar()"></button>
  }

  <aside
    class="manage-menu-shell__sidebar"
    [class.manage-menu-shell__sidebar--collapsed]="sidebarCollapsed"
    [class.manage-menu-shell__sidebar--mobile-open]="mobileSidebarOpen"
  >
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed" />
  </aside>

  <div class="manage-menu-shell__content">
    <app-dashboard-header
      [title]="''"
      [subtitle]="''"
      [user]="user"
      [currentTime]="''"
      (menuToggle)="handleMenuToggle()"
    />

    <main class="manage-menu-page">
      <section class="manage-menu-page__heading">
        <div class="manage-menu-page__heading-copy">
          <h2 class="app-title-serif">Manage Menu</h2>
        </div>

        <button type="button" class="app-button app-button--primary manage-menu-page__add-button" (click)="openAddMenuModal()">
          <span class="manage-menu-page__add-icon">+</span>
          <span>Add New Menu</span>
        </button>
      </section>

      <section class="manage-menu-page__filters app-card">
        <form class="manage-menu-filters" [formGroup]="filterForm">
          <label class="app-form-field manage-menu-filters__field">
            <span class="app-form-label">Search</span>
            <div class="manage-menu-filters__search">
              <span class="manage-menu-filters__search-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="7"></circle>
                  <path d="m20 20-3.5-3.5"></path>
                </svg>
              </span>
              <input class="app-form-input manage-menu-filters__search-input" type="text" placeholder="Search menus" formControlName="search" />
            </div>
          </label>

          <label class="app-form-field manage-menu-page__pagination-size">
            <span class="app-form-label">Page Size</span>
            <select class="app-form-select" [formControl]="pageSizeControl">
              @for (size of pageSizeOptions; track size) {
                <option [value]="size">{{ size }}</option>
              }
            </select>
          </label>

          <button type="button" class="app-button app-button--secondary equal app-filter-actions__button" [disabled]="isLoading" (click)="clearFilters()">
            Clear
          </button>
        </form>
      </section>

      <section class="manage-menu-page__table app-card">
        <div class="manage-menu-page__table-wrap app-table-scroll">
          <table class="manage-menu-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Menu</th>
                <th>Code</th>
                <th>Route</th>
                <th>Parent</th>
                <th>Order</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @if (isLoading) {
                <tr>
                  <td colspan="8" class="manage-menu-page__empty-state">Loading menus...</td>
                </tr>
              } @else if (menus.length) {
                @for (item of menus; track trackByMenuId($index, item)) {
                  <tr>
                    <td>{{ item.serial_no || item.display_order }}</td>
                    <td>
                      <div class="manage-menu-table__menu-copy">
                        <span class="manage-menu-table__menu-title">{{ item.menu_name }}</span>
                        <span class="manage-menu-table__menu-subtitle">{{ item.icon || '-' }}</span>
                      </div>
                    </td>
                    <td>{{ item.menu_code }}</td>
                    <td class="manage-menu-table__cell-text">{{ item.route_path || '-' }}</td>
                    <td>{{ getParentName(item) }}</td>
                    <td>{{ item.display_order }}</td>
                    <td>
                      <span class="app-pill" [class.app-pill--success]="item.is_active" [class.app-pill--muted]="!item.is_active">
                        {{ item.is_active ? 'Active' : 'Inactive' }}
                      </span>
                    </td>
                    <td>
                      <div class="manage-menu-page__actions">
                        <button type="button" class="app-button app-button--secondary manage-menu-page__small-button" (click)="openEditMenuModal(item)">
                          Edit
                        </button>
                        <button type="button" class="app-button app-button--danger manage-menu-page__small-button" (click)="deleteMenu(item)">
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                }
              } @else {
                <tr>
                  <td colspan="8" class="manage-menu-page__empty-state">No menus found.</td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <footer class="manage-menu-page__pagination">
          <div class="manage-menu-page__pagination-summary">
            {{ pagination.total_records }} records
          </div>
          <div class="manage-menu-page__pagination-pages">
            <button type="button" class="manage-menu-page__pagination-page" [disabled]="pagination.page_no <= 1" (click)="goToPage(pagination.page_no - 1)">
              Prev
            </button>
            @for (page of pageNumbers(); track page) {
              <button type="button" class="manage-menu-page__pagination-page" [class.active]="page === pagination.page_no" (click)="goToPage(page)">
                {{ page }}
              </button>
            }
            <button type="button" class="manage-menu-page__pagination-page" [disabled]="pagination.page_no >= pagination.total_pages" (click)="goToPage(pagination.page_no + 1)">
              Next
            </button>
          </div>
        </footer>
      </section>
    </main>
  </div>
</div>

@if (menuModalOpen) {
  <div class="app-modal-backdrop">
    <dialog class="app-modal manage-menu-modal" open>
      <div class="manage-menu-modal__header">
        <div>
          <h3 class="app-title-serif">{{ modalMode === 'create' ? 'Add Menu' : 'Edit Menu' }}</h3>
          <p>{{ modalMode === 'create' ? 'Create a sidebar/menu entry.' : 'Update this menu entry.' }}</p>
        </div>
        <button type="button" class="app-button app-button--icon manage-menu-modal__close" aria-label="Close modal" (click)="closeMenuModal()">×</button>
      </div>

      <form class="manage-menu-modal__body" [formGroup]="menuForm" (ngSubmit)="saveMenu()">
        <label class="app-form-field">
          <span class="app-form-label">Menu Name</span>
          <input class="app-form-input" type="text" formControlName="menu_name" />
          <small>{{ fieldError('menu_name', 'Menu name is required.') }}</small>
        </label>

        <label class="app-form-field">
          <span class="app-form-label">Menu Code</span>
          <input class="app-form-input" type="text" formControlName="menu_code" />
          <small>{{ fieldError('menu_code', 'Menu code is required.') }}</small>
        </label>

        <label class="app-form-field">
          <span class="app-form-label">Parent Menu</span>
          <select class="app-form-select" formControlName="parent_id">
            <option [ngValue]="null">No parent</option>
            @for (menu of getAvailableParents(); track menu.id) {
              <option [ngValue]="menu.id">{{ menu.menu_name }}</option>
            }
          </select>
          <small>&nbsp;</small>
        </label>

        <label class="app-form-field">
          <span class="app-form-label">Route Path</span>
          <input class="app-form-input" type="text" placeholder="/dashboard" formControlName="route_path" />
          <small>&nbsp;</small>
        </label>

        <label class="app-form-field">
          <span class="app-form-label">Icon Class</span>
          <input class="app-form-input" type="text" placeholder="fa-gauge" formControlName="icon" />
          <small>&nbsp;</small>
        </label>

        <label class="app-form-field">
          <span class="app-form-label">Display Order</span>
          <input class="app-form-input" type="number" formControlName="display_order" />
          <small>&nbsp;</small>
        </label>

        <label class="app-form-field">
          <span class="app-form-label">Phase</span>
          <input class="app-form-input" type="number" formControlName="phase" />
          <small>{{ fieldError('phase', 'Phase is required.') }}</small>
        </label>

        <label class="manage-menu-modal__toggle">
          <input type="checkbox" formControlName="is_active" />
          <span>Active</span>
        </label>

        <div class="manage-menu-modal__footer">
          <button type="button" class="app-button app-button--secondary" (click)="closeMenuModal()">Cancel</button>
          <button type="submit" class="app-button app-button--primary">{{ modalMode === 'create' ? 'Create Menu' : 'Update Menu' }}</button>
        </div>
      </form>
    </dialog>
  </div>
}
